export default __webpack_public_path__ + "static/media/CS-Mani.da553e64.webp";